var map = {
	"./en-US/terms-of-use.html": 616,
	"./nl-BE/terms-of-use.html": 619
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;



//////////////////
// WEBPACK FOOTER
// ./app/views/legal/partials terms-of-use\.html$
// module id = 335
// module chunks = 7